import {http, onSuccess, onSuccessWithHeaders, onFail} from './http';

export const commentGet = (roomKey, id) =>
    http.get(`/api/player/event/chatRoom/${roomKey}/message/${id}`)
        .then(onSuccess, onFail);

export const eventCommentGet = (eventKey, id) =>
    http.get(`/api/player/event/${eventKey}/comments/${id}`)
        .then(onSuccess, onFail);

export const commentsGet = (eventKey, params) =>
    http.get(`/api/player/event/${eventKey}/comments`, {params})
        .then(onSuccess, onFail);

export const commentCreate = (roomKey, data) =>
    http.post(`/api/player/event/chatRoom/${roomKey}/message`, data)
        .then(onSuccessWithHeaders, onFail);

export const eventCommentCreate = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/comments`, data)
        .then(onSuccessWithHeaders, onFail);

export const commentUpdate = (eventPassword, id, data) =>
    http.put(`/api/player/event/${eventPassword}/comments/${id}`, data)
        .then(onSuccess, onFail);

export const commentDelete = (eventPassword, id, params) =>
    http.delete(`/api/cp/event/${eventPassword}/comments/${id}`, {params})
        .then(onSuccess, onFail);

export const commentLikeToggle = (eventKey, id, rated) => (
    rated
        ? http.post(`/api/player/event/${eventKey}/comments/${id}/like`)
        : http.delete(`/api/player/event/${eventKey}/comments/${id}/like`)
    ).then(onSuccessWithHeaders, onFail);

export const commentDislikeToggle = (eventKey, id, rated) => (
    rated
        ? http.post(`/api/player/event/${eventKey}/comments/${id}/dislike`)
        : http.delete(`/api/player/event/${eventKey}/comments/${id}/dislike`)
    ).then(onSuccessWithHeaders, onFail);

export const commentLectorModal = (eventKey, eventPassword, id, sender) => (
    id > 0
        ? http.post(`/api/player/event/${eventKey}/comments/${id}/lectorModal`, {eventPassword, id, sender})
        : http.delete(`/api/player/event/${eventKey}/comments/lectorModal`, {params: {eventPassword}})
    ).then(onSuccess, onFail);
